/**
 * 
 * @param {*} color  主题色
 * @param {*} errorColor 错误辅助色
 * @param {*} SuccessColor  成功的辅助色
 * @param {*} WarningColor  警告的辅助色
 * @param {*} InfoColor  正常的辅助色
 * @param {*} SuccessColor 
 */
export function setThemeColor(color='#409EFF',SuccessColor='#67c23a',WarningColor='#E6A23C',errorColor='#F56C6C',InfoColor="#909399") {
  const el = document.documentElement;
  const body = document.querySelector("body");
  // const nprogress = document.querySelector("#nprogress .bar");
  el.style.setProperty("--el-color-primary", color);
  el.style.setProperty("--themeColor", color);
  // 错误
  el.style.setProperty("--el-color-danger", errorColor);
  el.style.setProperty("--el-color-error", errorColor);
  // 成功
  el.style.setProperty("--el-color-success", SuccessColor);
  // 警告
  el.style.setProperty("--el-color-warning", WarningColor);
  // 正常
  el.style.setProperty("--el-color-info", InfoColor);
  
  body.style.setProperty("--van-primary-color", color);
  // nprogress.style.setProperty("background", color);
  // 此行判断是否为白天/暗夜模式，可根据自身业务调整代码
  // let mixColor = Store.state.settings.sideTheme.split("-")[1] === "light" ? "#ffffff" : "#000000"; 
  // 此行判断是否为白天/暗夜模式，可根据自身业务调整代码
  for (let i = 1; i < 10; i++) {
    el.style.setProperty(`--el-color-primary-light-${i}`, colourBlend(color, '#ffffff', i / 10));
    el.style.setProperty(`--el-color-primary-dark-${i}`, colourBlend(color, '#ffffff', i / 10));
    el.style.setProperty(`--el-color-danger-light-${i}`, colourBlend(errorColor, '#ffffff', i / 10));
    el.style.setProperty(`--el-color-error-light-${i}`, colourBlend(errorColor, '#ffffff', i / 10));
    el.style.setProperty(`--el-color-success-light-${i}`, colourBlend(SuccessColor||'#67c23a', '#ffffff', i / 10));
    el.style.setProperty(`--el-color-warning-light-${i}`, colourBlend(WarningColor||'#67c23a', '#ffffff', i / 10));
    el.style.setProperty(`--el-color-info-light-${i}`, colourBlend(InfoColor||'#67c23a', '#ffffff', i / 10));
  }
  el.style.setProperty(`--el-color-primary-dark-2`, colourBlend(color, '#ffffff', 0.2));

}

export function colourBlend(c1, c2, ratio) {
  ratio = Math.max(Math.min(Number(ratio), 1), 0)
  let r1 = parseInt(c1.substring(1, 3), 16)
  let g1 = parseInt(c1.substring(3, 5), 16)
  let b1 = parseInt(c1.substring(5, 7), 16)
  let r2 = parseInt(c2.substring(1, 3), 16)
  let g2 = parseInt(c2.substring(3, 5), 16)
  let b2 = parseInt(c2.substring(5, 7), 16)
  let r = Math.round(r1 * (1 - ratio) + r2 * ratio)
  let g = Math.round(g1 * (1 - ratio) + g2 * ratio)
  let b = Math.round(b1 * (1 - ratio) + b2 * ratio)
  r = ('0' + (r || 0).toString(16)).slice(-2)
  g = ('0' + (g || 0).toString(16)).slice(-2)
  b = ('0' + (b || 0).toString(16)).slice(-2)
  return '#' + r + g + b
}
